<mat-form-field subscriptSizing="dynamic">
  <mat-label>Choose Action</mat-label>
  <mat-select [formControl]="selectControl"
    (selectionChange)="onActionSelected($event)">
    @for (group of groups; track group.name) {
      <mat-optgroup
        [label]="group.name">
        @for (action of group.actions; track action.value) {
          <mat-option
            [value]="action.value"
            [disabled]="action.disabled">
            {{action.label}}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>

  @if (hint) {
    <mat-hint>{{hint}}</mat-hint>
  }
</mat-form-field>
